export const SET_QUOTE_MODEL_REVISION_ID = 'SET_QUOTE_MODEL_REVISION_ID'
